import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { EmptyDeskIcon, MegaphoneIcon } from 'secondstep-components'
import {
  ButtonText,
  ButtonTextLink,
  LeftContentWrapper,
  RightContentWrapper,
  LeftBox,
  PrimaryText,
  ProgramToStaffButton,
  ProgramToStaffButtonContent,
  RightBox,
  SecondaryText,
  StaffTrainingButton,
  StaffTrainingButtonContent,
  StyledAwardIcon,
  StyledHairline,
  DwbEmptyReportHeading,
  DwbEmptyReportMessage,
  DwbEmptyReportMessageBox,
  DwbEmptyReportSection,
  Wrapper,
} from './component.styles'
import NavigationHelper from 'layers/navigation/navigationHelper'
import {
  DWB_LESSON_PROGRESS_MESSAGE,
  DWB_UNIT_HEADING,
  LESSON_PROGRESS_MESSAGE,
  PROGRAM_INTRODUCTION_LINK,
  PROGRAM_TO_STAFF_LINK_TEXT,
  SCHOOL_KICK_OFF_MESSAGE,
  STAFF_TRAINING_LINK,
  STAFF_TRAINING_LINK_TEXT,
  TEACHER_CLASS_MESSAGE,
  TEACHER_TRAINING_MESSAGE,
} from './constants'

const AdminNoClasses = ({
  isDwbEmptyReport = false,
  isSpecializedUnitsView = false,
  navigationEvent,
}) => {
  const navigateToProgramIntroduction = () => {
    const type = NavigationHelper.types.NEW_TAB
    navigationEvent(PROGRAM_INTRODUCTION_LINK, type)
  }

  const navigateToStaffTraining = () => {
    const type = NavigationHelper.types.NEW_TAB
    navigationEvent(STAFF_TRAINING_LINK, type)
  }

  // TODO: remove this once the specialized lesson completion updates are on
  if (isDwbEmptyReport) {
    return (
      <DwbEmptyReportSection>
        <DwbEmptyReportHeading>{DWB_UNIT_HEADING}</DwbEmptyReportHeading>
        <DwbEmptyReportMessageBox>
          <EmptyDeskIcon />
          <DwbEmptyReportMessage>
            {DWB_LESSON_PROGRESS_MESSAGE}
          </DwbEmptyReportMessage>
        </DwbEmptyReportMessageBox>
      </DwbEmptyReportSection>
    )
  }

  return (
    <Wrapper>
      <LeftContentWrapper>
        <LeftBox>
          <EmptyDeskIcon />
          <PrimaryText>{LESSON_PROGRESS_MESSAGE}</PrimaryText>
          {!isSpecializedUnitsView && (
            <SecondaryText>{TEACHER_CLASS_MESSAGE}</SecondaryText>
          )}
        </LeftBox>
      </LeftContentWrapper>
      {!isSpecializedUnitsView && (
        <Fragment key="empty-dwb-report">
          <StyledHairline />
          <RightContentWrapper>
            <RightBox>
              <ProgramToStaffButton onClick={navigateToProgramIntroduction}>
                <MegaphoneIcon />
                <ProgramToStaffButtonContent>
                  <ButtonText>{SCHOOL_KICK_OFF_MESSAGE}</ButtonText>
                  <ButtonTextLink>{PROGRAM_TO_STAFF_LINK_TEXT}</ButtonTextLink>
                </ProgramToStaffButtonContent>
              </ProgramToStaffButton>
              <StaffTrainingButton onClick={navigateToStaffTraining}>
                <StyledAwardIcon />
                <StaffTrainingButtonContent>
                  <ButtonText>{TEACHER_TRAINING_MESSAGE}</ButtonText>
                  <ButtonTextLink>{STAFF_TRAINING_LINK_TEXT}</ButtonTextLink>
                </StaffTrainingButtonContent>
              </StaffTrainingButton>
            </RightBox>
          </RightContentWrapper>
        </Fragment>
      )}
    </Wrapper>
  )
}

AdminNoClasses.propTypes = {
  isDwbEmptyReport: PropTypes.bool,
  isSpecializedUnitsView: PropTypes.bool,
  navigationEvent: PropTypes.func,
}

export default AdminNoClasses
